import EventIcon from "@mui/icons-material/Event";
import { DialogActions, DialogContent } from "@mui/material";
import {
  Button,
  Field,
  FieldsContainer,
  Form,
  PageHeader,
  TextField,
} from "common";
import useAccess from "features/profile/useAccess";
import I18n from "i18n";
import useShiftGroupForm, {
  getMinutesOffset,
  UseShiftGroupFormProps,
} from "./useShiftGroupForm";

export interface ShiftGroupFormProps extends UseShiftGroupFormProps {}

export default function ShiftGroupForm({
  onClose,
  afterSave,
}: ShiftGroupFormProps) {
  const { hasPermissions, canEditItem } = useAccess();

  const {
    item,
    options,
    errors,
    loading,
    isDirty,
    getIsDirty,
    getRequiredFields,
    onChange,
    save,
    saving,
  } = useShiftGroupForm({ afterSave });

  const title = I18n.t("EventEditor.shiftGroupTitle");
  const subtitle = getMinutesOffset(item) + " perc";
  return (
    <>
      <PageHeader
        avatar={<EventIcon />}
        title={title}
        subtitle={subtitle}
        onClose={onClose}
        loading={loading}
      />
      <DialogContent>
        <Form
          loading={loading}
          item={item}
          options={options}
          errors={errors}
          onChange={onChange}
          translationCategory="EventEditor.attributes"
          translationPlaceholdersCategory="EventEditor.placeholders"
          translationHelpersCategory="EventEditor.helpers"
          isDirty={getIsDirty}
          requiredFields={getRequiredFields()}
          disabled={!canEditItem("event_group", item)}
        >
          <FieldsContainer>
            <Field fullWidth>
              <TextField
                useDelayedKeystrokes={false}
                id="days"
                mask={Number}
                numberOptions={{ scale: 0 }}
              />
            </Field>
            <Field fullWidth>
              <TextField
                useDelayedKeystrokes={false}
                id="hours"
                mask={Number}
                numberOptions={{ scale: 0 }}
              />
            </Field>
            <Field fullWidth>
              <TextField
                useDelayedKeystrokes={false}
                id="minutes"
                mask={Number}
                numberOptions={{ scale: 0 }}
              />
            </Field>
          </FieldsContainer>
        </Form>
      </DialogContent>
      <DialogActions>
        <Button
          title={I18n.t("EventEditor.save")}
          disabled={!isDirty}
          onClick={() => save()}
          loading={saving}
        />
      </DialogActions>
    </>
  );
}
